export interface LangFormatProps {
  'DD MMM': string
  'DD [de] MMMM': string
  'DD MMM, YYYY': string
  'DD/MM/YY': string
  'DD/MM/YYYY'?: string
  'DD/MM/YYYY HH:mm'?: string
  'HH:mm'?: string
  'HH:mm:ss'?: string
  'D [de] MMMM [de] YYYY'?: string
  'D [de] MMMM [de] YYYY [às] HH:mm'?: string
}

const defaultValues: Required<LangFormatProps> = {
  'DD MMM': 'DD MMM',
  'DD [de] MMMM': 'DD [de] MMMM',
  'DD MMM, YYYY': 'DD MMM, YYYY',
  'DD/MM/YY': 'DD/MM/YY',
  'DD/MM/YYYY': 'L',
  'DD/MM/YYYY HH:mm': 'L LT',
  'HH:mm': 'LT',
  'HH:mm:ss': 'LTS',
  'D [de] MMMM [de] YYYY': 'LL',
  'D [de] MMMM [de] YYYY [às] HH:mm': 'LLL'
}

const enValues: LangFormatProps = {
  'DD/MM/YY': 'MM/DD/YY',
  'DD MMM': 'MMM DD',
  'DD MMM, YYYY': 'll',
  'DD [de] MMMM': 'MMMM DD'
}

const ptValues: LangFormatProps = {
  'DD/MM/YY': 'DD/MM/YY',
  'DD MMM': 'DD MMM',
  'DD MMM, YYYY': 'DD MMM, YYYY',
  'DD [de] MMMM': 'DD [de] MMMM'
}

const esValues: LangFormatProps = {
  'DD/MM/YY': 'DD/MM/YY',
  'DD MMM': 'DD MMM',
  'DD MMM, YYYY': 'DD MMM, YYYY',
  'DD [de] MMMM': 'DD [de] MMMM'
}

interface LocalizedFormatStringProps extends Record<string, LangFormatProps> {
  default: Required<LangFormatProps>
  en: LangFormatProps
  'pt-br': LangFormatProps
  es: LangFormatProps
}

export const localizedFormatString: LocalizedFormatStringProps = {
  default: defaultValues,
  en: enValues,
  es: esValues,
  'pt-br': ptValues
}
